/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiConversionSimplifiedFromJSON, ApiConversionSimplifiedToJSON, } from './ApiConversionSimplified';
import { ApiFormSimplifiedFromJSON, ApiFormSimplifiedToJSON, } from './ApiFormSimplified';
import { ApiJobTaggerSimplifiedFromJSON, ApiJobTaggerSimplifiedToJSON, } from './ApiJobTaggerSimplified';
import { ApiLocationItemSimplifiedFromJSON, ApiLocationItemSimplifiedToJSON, } from './ApiLocationItemSimplified';
import { ApiLocationPageTaggerSimplifiedFromJSON, ApiLocationPageTaggerSimplifiedToJSON, } from './ApiLocationPageTaggerSimplified';
import { ApiLocationVelocityTypeFromJSON, ApiLocationVelocityTypeToJSON, } from './ApiLocationVelocityType';
import { ApiPageSimplifiedFromJSON, ApiPageSimplifiedToJSON, } from './ApiPageSimplified';
import { ApiPageTypeSimplifiedFromJSON, ApiPageTypeSimplifiedToJSON, } from './ApiPageTypeSimplified';
import { ApiProductTaggerSimplifiedFromJSON, ApiProductTaggerSimplifiedToJSON, } from './ApiProductTaggerSimplified';
import { ApiProjectDefaultFromJSON, ApiProjectDefaultToJSON, } from './ApiProjectDefault';
import { ApiProjectSimplifiedFromJSON, ApiProjectSimplifiedToJSON, } from './ApiProjectSimplified';
export function ApiLocationFromJSON(json) {
    return ApiLocationFromJSONTyped(json, false);
}
export function ApiLocationFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'automate': !exists(json, 'automate') ? undefined : json['automate'],
        'clickToInteraction': !exists(json, 'clickToInteraction') ? undefined : json['clickToInteraction'],
        'conversions': !exists(json, 'conversions') ? undefined : (json['conversions'].map(ApiConversionSimplifiedFromJSON)),
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        '_default': !exists(json, 'default') ? undefined : ApiProjectDefaultFromJSON(json['default']),
        'deletedAt': !exists(json, 'deletedAt') ? undefined : (new Date(json['deletedAt'])),
        'formTaggers': !exists(json, 'formTaggers') ? undefined : (json['formTaggers'].map(ApiFormSimplifiedFromJSON)),
        'id': !exists(json, 'id') ? undefined : json['id'],
        'items': !exists(json, 'items') ? undefined : (json['items'].map(ApiLocationItemSimplifiedFromJSON)),
        'jobTaggers': !exists(json, 'jobTaggers') ? undefined : (json['jobTaggers'].map(ApiJobTaggerSimplifiedFromJSON)),
        'name': !exists(json, 'name') ? undefined : json['name'],
        'onboardingId': !exists(json, 'onboardingId') ? undefined : json['onboardingId'],
        'pageTypes': !exists(json, 'pageTypes') ? undefined : (json['pageTypes'].map(ApiPageTypeSimplifiedFromJSON)),
        'pages': !exists(json, 'pages') ? undefined : (json['pages'].map(ApiPageSimplifiedFromJSON)),
        'productTaggers': !exists(json, 'productTaggers') ? undefined : (json['productTaggers'].map(ApiProductTaggerSimplifiedFromJSON)),
        'project': !exists(json, 'project') ? undefined : ApiProjectSimplifiedFromJSON(json['project']),
        'projectId': !exists(json, 'projectId') ? undefined : json['projectId'],
        'showInAnalytics': !exists(json, 'showInAnalytics') ? undefined : json['showInAnalytics'],
        'taggers': !exists(json, 'taggers') ? undefined : (json['taggers'].map(ApiLocationPageTaggerSimplifiedFromJSON)),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
        'urlMatch': !exists(json, 'urlMatch') ? undefined : json['urlMatch'],
        'velocityLimit': !exists(json, 'velocityLimit') ? undefined : json['velocityLimit'],
        'velocityRender': !exists(json, 'velocityRender') ? undefined : json['velocityRender'],
        'velocityType': !exists(json, 'velocityType') ? undefined : ApiLocationVelocityTypeFromJSON(json['velocityType']),
    };
}
export function ApiLocationToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'automate': value.automate,
        'clickToInteraction': value.clickToInteraction,
        'conversions': value.conversions === undefined ? undefined : (value.conversions.map(ApiConversionSimplifiedToJSON)),
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'default': ApiProjectDefaultToJSON(value._default),
        'deletedAt': value.deletedAt === undefined ? undefined : (value.deletedAt.toISOString()),
        'formTaggers': value.formTaggers === undefined ? undefined : (value.formTaggers.map(ApiFormSimplifiedToJSON)),
        'id': value.id,
        'items': value.items === undefined ? undefined : (value.items.map(ApiLocationItemSimplifiedToJSON)),
        'jobTaggers': value.jobTaggers === undefined ? undefined : (value.jobTaggers.map(ApiJobTaggerSimplifiedToJSON)),
        'name': value.name,
        'onboardingId': value.onboardingId,
        'pageTypes': value.pageTypes === undefined ? undefined : (value.pageTypes.map(ApiPageTypeSimplifiedToJSON)),
        'pages': value.pages === undefined ? undefined : (value.pages.map(ApiPageSimplifiedToJSON)),
        'productTaggers': value.productTaggers === undefined ? undefined : (value.productTaggers.map(ApiProductTaggerSimplifiedToJSON)),
        'project': ApiProjectSimplifiedToJSON(value.project),
        'projectId': value.projectId,
        'showInAnalytics': value.showInAnalytics,
        'taggers': value.taggers === undefined ? undefined : (value.taggers.map(ApiLocationPageTaggerSimplifiedToJSON)),
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
        'urlMatch': value.urlMatch,
        'velocityLimit': value.velocityLimit,
        'velocityRender': value.velocityRender,
        'velocityType': ApiLocationVelocityTypeToJSON(value.velocityType),
    };
}
